import { Slider, SliderProps } from '@mantine/core';
import { AiIcon } from '@zorro/shared/assets';
import { ReactNode, forwardRef } from 'react';

import { ITextProps, ZorroText } from '../Text';
import classNames from './Slider.module.scss';

type MarkLabelProps = ITextProps & {
  children?: ReactNode;
  isOnTop?: boolean;
};

const MarkLabel = ({ isOnTop, children }: MarkLabelProps) => {
  return (
    <ZorroText
      bottom={isOnTop ? '3.75rem' : '-0.25rem'}
      pos="relative"
      c="zorroGray.4"
      left="0.25rem"
    >
      {children}
    </ZorroText>
  );
};

/** @deprecated Use `Slider` from `@zorro/design-system/v2/Slider` instead. Kept for `variant="ai"` until the V2 AI variant ships. */
export type ISliderProps = SliderProps & {
  value: number;
  variant?: 'ai';
  aiSliderBackgroundColor?: string;
};

const translateOffsetCalculation = (value: number, max: number = 100) => {
  return (value / (max || 100)) * 100;
};

const ZorroSliderBase = forwardRef<HTMLInputElement, ISliderProps>(
  (
    {
      variant,
      value,
      label = (value) => value,
      aiSliderBackgroundColor = 'var(--mantine-color-zorroWhite-0)',
      ...props
    },
    ref
  ) => {
    return (
      <Slider
        {...props}
        label={label}
        value={value}
        data-variant={variant}
        classNames={classNames}
        style={{
          '--slider-background-color': aiSliderBackgroundColor,
          '--slider-bar-ai-offset': `calc(100% - ${translateOffsetCalculation(value, props.max)}%)`,
        }}
        thumbChildren={
          variant === 'ai' ? (
            <AiIcon style={{ minWidth: 32, minHeight: 32 }} />
          ) : undefined
        }
        ref={ref}
      />
    );
  }
);

/** @deprecated Use `Slider` from `@zorro/design-system/v2/Slider` instead. Kept for `variant="ai"` until the V2 AI variant ships. */
export const ZorroSlider = Object.assign(ZorroSliderBase, { MarkLabel });
